export default "__VITE_ASSET__C_KcamJ7__"